enum SectionViewControllerType
{    
    None,
    Product = "99000000-0000-1111-1111-000000000001",    
    ProductCategory = "99000000-0000-1111-1111-000000000002",
    Menus = "99000000-0000-1111-1111-000000000003",
    ProductModifiers = "99000000-0000-1111-1111-000000000004",
    POSInvoices = "99000000-0000-1111-1111-000000000005",
    POSTickets = "99000000-0000-1111-1111-000000000006",
    Logs = "99000000-0000-1111-1111-000000000007",
    CashDesk = "99000000-0000-1111-1111-000000000008",
    StockTemplates = "99000000-0000-1111-1111-000000000009",
    Client = "99000000-0000-1111-1111-000000000010",
    Worker = "99000000-0000-1111-1111-000000000011",
    Supplier = "99000000-0000-1111-1111-000000000012",
    Bookings = "99000000-0000-1111-1111-000000000013",
    NoShow = "99000000-0000-1111-1111-000000000014",
    SalesSummary = "99000000-0000-1111-1111-000000000015",
    ReportBuilder = "99000000-0000-1111-1111-000000000016",
    Stock = "99000000-0000-1111-1111-000000000017",
    WarehouseOrder = "99000000-0000-1111-1111-000000000018",
    AdvancedReports = "99000000-0000-1111-1111-000000000019",
    PartyEvents = "99000000-0000-1111-1111-000000000021",
    Offers = "99000000-0000-1111-1111-000000000022",
    Guests = "99000000-0000-1111-1111-000000000023",
    SupplierReturnNote = "99000000-0000-1111-1111-000000000024",
    BookingIntermediary = "99000000-0000-1111-1111-000000000025",
    Events = "99000000-0000-1111-1111-000000000026",
    SupplierNote = "99000000-0000-1111-1111-000000000027",
    InventoryNote = "99000000-0000-1111-1111-000000000028",
    MovementNote = "99000000-0000-1111-1111-000000000029",
    TransferNote = "99000000-0000-1111-1111-000000000020",
    WarehouseDelivery = "99000000-0000-1111-1111-000000000030",
    GuestLists = "99000000-0000-1111-1111-000000000031",
    PurchaseInvoices = "99000000-0000-1111-1111-000000000032",
    Settings = "99000000-0000-1111-1111-000000000033",
    SupportFiles ="99000000-0000-1111-1111-000000000034",
    OutputNote = "99000000-0000-1111-1111-000000000035",
    SupportTickets = "99000000-0000-1111-1111-000000000036",
    QuotationDocuments = "99000000-0000-1111-1111-000000000037",
    DeliveryNote = "99000000-0000-1111-1111-000000000038",
    ApplicationLicenses = "99000000-0000-1111-1111-000000000039",
    BusinessLicenses = "99000000-0000-1111-1111-000000000086",
    DBBackup = "99000000-0000-1111-1111-000000000040",
    DBTool = "99000000-0000-1111-1111-000000000041",
    OperationSummary = "99000000-0000-1111-1111-000000000042",
    WorkerAdmin = "99000000-0000-1111-1111-000000000043",
    //DOCUMENT TRACKING = "99000000-0000-1111-1111-000000000044",
    //VIP CARDS = "99000000-0000-1111-1111-000000000045",
    //VIP RESPONSIBLES = "99000000-0000-1111-1111-000000000046",
    Parties = "99000000-0000-1111-1111-000000000047",
    WarehouseInput = "99000000-0000-1111-1111-000000000048",
    Cards = "99000000-0000-1111-1111-000000000049",
    DBMapping = "99000000-0000-1111-1111-000000000050",
    DBSync = "99000000-0000-1111-1111-000000000051",
    SyncLog = "99000000-0000-1111-1111-000000000052",
    ProductAdmin = "99000000-0000-1111-1111-000000000053",
    UserAccess = "99000000-0000-1111-1111-000000000054",
    LowStockOrder = "99000000-0000-1111-1111-000000000055",
    SupplierOrder = "99000000-0000-1111-1111-000000000056",
    DeliveryOrder = "99000000-0000-1111-1111-000000000057",
    BankAccount = "99000000-0000-1111-1111-000000000058",
    DashBoard = "99000000-0000-1111-1111-000000000059",
    StockFlowsSummary = "99000000-0000-1111-1111-000000000060",
    OrdersSummary = "99000000-0000-1111-1111-000000000061",
    ProductMixSummary = "99000000-0000-1111-1111-000000000062",
    ClientHistorySummary = "99000000-0000-1111-1111-000000000063",
    WorkerSessionTool = "99000000-0000-1111-1111-000000000064",
    RoomSchedule = "99000000-0000-1111-1111-000000000065",
    RoomBooking = "99000000-0000-1111-1111-000000000066",
    DBImport = "99000000-0000-1111-1111-000000000067",
    DeliveryRoutes = "99000000-0000-1111-1111-000000000068",
    ProductRates = "99000000-0000-1111-1111-000000000069",
    ProductPresets = "99000000-0000-1111-1111-000000000070",
    Partners = "99000000-0000-1111-1111-000000000071",
    BuyOrder = "99000000-0000-1111-1111-000000000072",
    OnlineOrders = "99000000-0000-1111-1111-000000000073",
    Places = "99000000-0000-1111-1111-000000000074",
    OnlinePlatforms = "99000000-0000-1111-1111-000000000075",
    TableMap = "99000000-0000-1111-1111-000000000076",
    AppConfiguration = "99000000-0000-1111-1111-000000000077",
    WorkerClockIn = "99000000-0000-1111-1111-000000000078",
    Distributors = "99000000-0000-1111-1111-000000000079",
    Resellers = "99000000-0000-1111-1111-000000000080",
    Agents = "99000000-0000-1111-1111-000000000081",
    SalesInvoices = "99000000-0000-1111-1111-000000000082",
    DBConsumptionLog = "99000000-0000-1111-1111-000000000083",
    InputNote = "99000000-0000-1111-1111-000000000084",
    AppConsumptionProfile = "99000000-0000-1111-1111-000000000085",
    Expenses = "99000000-0000-1111-1111-000000000087",
    Loans = "99000000-0000-1111-1111-000000000088",
    SalaryPayroll = "99000000-0000-1111-1111-000000000089",
    LedgerAccountReconciliation = "99000000-0000-1111-1111-000000000090",
    PaymentInstallments = "99000000-0000-1111-1111-000000000091",
    PendingPayments = "99000000-0000-1111-1111-000000000092",
    WineCellarProducts = "99000000-0000-1111-1111-000000000093"    
}

class SectionHelperCache extends MIOObject
{
    private section_by_type = {};

    sectionByType( type:SectionViewControllerType, newInstanceBlock:() => MUIViewController) : MUIViewController {
        let vc = this.section_by_type[type];
        if (vc == null) {
            vc = newInstanceBlock();
            this.section_by_type[type] = vc;
        }
        return vc;
    }

    reset(){
        this.section_by_type = {};
    }
}
class SectionHelper extends MIOObject
{
    static get sectionCount() { return 93 };

    private static _sharedInstance: SectionHelper = null;
    static sharedInstance(): SectionHelper {

        if (this._sharedInstance == null) {
            this._sharedInstance = new SectionHelper();
            this._sharedInstance.init();
        }

        return this._sharedInstance;
    }

    private section_cache = new SectionHelperCache();

    // init(){
    //     super.init();
    //     MIONotificationCenter.defaultCenter().addObserver(this, "WorkspaceDidChange", function(this:SectionHelper, notification:MIONotification){            
    //         this.reset();
    //     });
    // }

    private showAll = false;
    private _manager_sections:any[] = [];
    private _manager_section_by_id = {};
    get managerSections(){ return this._manager_sections; }
    set managerSections(sections:ManagerSectionLocalized[]) {        
        let permisisons = SettingsHelper.sharedInstance().permisisons;        
        let currentSectionName = null;
        let currentSection = {"Name": null, "Rows" : []};
        this._manager_sections = [];        
        for (let index = 0; index < sections.count; index++){
            let section = sections[index] as ManagerSectionLocalized;
            if (currentSectionName != section.module) {
                if (currentSection != null) {
                    let rws = currentSection["Rows"];
                    if (rws.length > 0) this._manager_sections.addObject(currentSection);
                }
                currentSectionName = section.module;
                currentSection = {"Name": section.module, "Rows" : []};
            }
            let bitIndex = section.managerSection.bitPosition;
            let value = permisisons[bitIndex];
            if (value == "1" || this.showAll == true) {
                let rows = currentSection["Rows"];
                rows.addObject(section);
                currentSection["Rows"] = rows;
                this._manager_section_by_id[section.identifier] = section;
            }
        }
        
        if (currentSection != null){
            let rows = currentSection["Rows"];
            if (rows.length > 0) this._manager_sections.addObject(currentSection);
        }
    }

    sectionByID(sectionID:string) : ManagerSection {
        return this._manager_section_by_id[sectionID];
    }
    
    
    sectionsViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.None, () => {
            let vc = new SectionListViewController("section-list-view");
            vc.initWithResource("layout/sections/SectionListView.html");
            vc.modalPresentationStyle = MUIModalPresentationStyle.Custom;
            return vc;
        });
    }

    sectionViewControllerForType(type):MUIViewController {

        switch (type) {
            case SectionViewControllerType.DashBoard:           return this.dashBoardViewController();
            case SectionViewControllerType.OperationSummary:    return this.operationSummaryViewController();
            case SectionViewControllerType.SalesSummary:        return this.salesSummaryViewController();
            case SectionViewControllerType.StockFlowsSummary:   return this.stockFlowsSummaryViewController();
            case SectionViewControllerType.OrdersSummary:       return this.ordersSummaryViewController();
            case SectionViewControllerType.ProductMixSummary:   return this.productMixSummaryViewController();    
            case SectionViewControllerType.ClientHistorySummary: return this.clientHistorySummaryViewController();  
            case SectionViewControllerType.AdvancedReports:     return this.advancedReportsViewController();
            case SectionViewControllerType.Logs:                return this.logsViewController();

            // ACOUNTING
            case SectionViewControllerType.CashDesk:            return this.cashdeskViewController();
            case SectionViewControllerType.POSTickets:          return this.ticketsViewController();
            case SectionViewControllerType.POSInvoices:         return this.posInvoicesViewController();
            case SectionViewControllerType.QuotationDocuments:  return this.quotationDocumentsViewController();
            case SectionViewControllerType.SalesInvoices:       return this.salesInvoicesViewController();
            case SectionViewControllerType.PurchaseInvoices:    return this.purchaseInvoicesViewController();
            case SectionViewControllerType.BankAccount:         return this.banksViewController();
            case SectionViewControllerType.LedgerAccountReconciliation: return this.ledgerAccountReconciliationViewController();
            case SectionViewControllerType.PaymentInstallments: return this.paymentInstallmentsViewController();
            case SectionViewControllerType.PendingPayments:     return this.pendingPaymentsViewController();
            case SectionViewControllerType.Loans:               return this.loansViewController();
                
            // USERS
            case SectionViewControllerType.Client:              return this.clientsViewController();            
            case SectionViewControllerType.Worker:              return this.workersViewController();
            case SectionViewControllerType.WorkerAdmin:         return this.workersAdminViewController();
            case SectionViewControllerType.UserAccess:          return this.userAccessViewController();
            case SectionViewControllerType.Cards:               return this.cardsViewController();			
			case SectionViewControllerType.WorkerSessionTool:   return this.workerSessionToolViewController();
            case SectionViewControllerType.Partners:            return this.partnersViewController();    
            case SectionViewControllerType.WorkerClockIn:       return this.clockinViewController();

            // PRODUCTS            
            case SectionViewControllerType.Product:             return this.productsViewController();
            case SectionViewControllerType.ProductCategory:     return this.categoriesViewController();            
            case SectionViewControllerType.ProductModifiers:    return this.productModifiersViewController();
            case SectionViewControllerType.Menus:               return this.menusViewController();
            case SectionViewControllerType.ProductAdmin:        return this.productComponentsViewController();
            case SectionViewControllerType.Offers:              return this.offersViewController();
            case SectionViewControllerType.ProductRates:        return this.productRatesViewController();
            case SectionViewControllerType.ProductPresets:      return this.productPresetsViewController();
            case SectionViewControllerType.WineCellarProducts:  return this.wineCellarProductsViewController();

            // BOOKINGS
            case SectionViewControllerType.Bookings:            return this.bookingsViewController();
            case SectionViewControllerType.NoShow:              return this.noShowViewController();
            case SectionViewControllerType.Guests:              return this.guestsViewController();
            case SectionViewControllerType.GuestLists:          return this.guestListViewController();
            case SectionViewControllerType.BookingIntermediary: return this.bookingIntermediaryViewController();
            case SectionViewControllerType.Events:              return this.eventsViewController();
            case SectionViewControllerType.Parties:             return this.partiesViewController();
            case SectionViewControllerType.PartyEvents:         return this.partyEventsViewController();

            // STOCK
            case SectionViewControllerType.Supplier:            return this.suppliersViewController();
            case SectionViewControllerType.Stock:               return this.stockViewController();            
            case SectionViewControllerType.InventoryNote:       return this.inventoryNotesViewController();
            case SectionViewControllerType.StockTemplates:      return this.inventoryTemplateViewController();
            case SectionViewControllerType.MovementNote:        return this.movementNotesViewController();
            case SectionViewControllerType.TransferNote:        return this.transferNotesViewController();
            case SectionViewControllerType.OutputNote:          return this.outputNotesViewController();
            case SectionViewControllerType.InputNote:           return this.inputNotesViewController();
            case SectionViewControllerType.LowStockOrder:       return this.lowStockProductViewController();
            case SectionViewControllerType.BuyOrder:            return this.buyOrdersViewController();
            case SectionViewControllerType.SupplierOrder:       return this.supplierOrdersViewController();
            case SectionViewControllerType.SupplierNote:        return this.supplierNotesViewController();
            case SectionViewControllerType.SupplierReturnNote:  return this.supplierReturnNotesViewController();
            case SectionViewControllerType.DeliveryNote:        return this.deliveryNotesViewController();
            case SectionViewControllerType.DeliveryOrder:       return this.deliveryOrdersViewController();
            case SectionViewControllerType.WarehouseOrder:      return this.warehouseOrdersViewController();
            case SectionViewControllerType.WarehouseDelivery:   return this.warehouseDeliveryViewController();
            case SectionViewControllerType.WarehouseInput:      return this.internalReturnOrderViewController();                       

            // ONLINE
            case SectionViewControllerType.DeliveryRoutes:      return this.deliveryRoutesController();
            case SectionViewControllerType.OnlinePlatforms:     return this.onlinePlatformsViewController();
            case SectionViewControllerType.OnlineOrders:        return this.onlineOrdersViewController();

            // CONFIGURATION
            case SectionViewControllerType.Settings:            return this.settingsViewController();
            case SectionViewControllerType.Places:              return this.placesViewController();
            case SectionViewControllerType.DBBackup:            return this.dbBackupToolViewController();
            case SectionViewControllerType.DBTool:              return this.dbToolViewController();
            case SectionViewControllerType.DBMapping:           return this.dbMappingViewController();
            case SectionViewControllerType.DBSync:              return this.dbSyncViewController();
            case SectionViewControllerType.SyncLog:             return this.syncLogViewController();
            case SectionViewControllerType.DBImport:            return this.dbImportViewController();
            case SectionViewControllerType.DBConsumptionLog:    return this.dbConsumptionLogViewController();
            case SectionViewControllerType.ReportBuilder:       return this.reportBuilderViewController();
            case SectionViewControllerType.AppConfiguration:    return this.appConfigurationViewController();
            case SectionViewControllerType.TableMap:            return this.tableMapViewController();
            case SectionViewControllerType.AppConsumptionProfile: return this.appConsumptionProfileViewController();

            // DUAL LINK
            case SectionViewControllerType.ApplicationLicenses: return this.licensesViewController();
            case SectionViewControllerType.BusinessLicenses:    return this.businessLicensesViewController();
            case SectionViewControllerType.SupportTickets:      return this.supportTicketsViewController();
            case SectionViewControllerType.SupportFiles:        return this.supportFilesViewController();

            // ROOMS
            case SectionViewControllerType.RoomSchedule:        return this.roomScheduleController();
            case SectionViewControllerType.RoomBooking:         return this.roomBookingController();

            // INTERMEDIARIES
            case SectionViewControllerType.Distributors:        return this.distributorsViewController();
            case SectionViewControllerType.Agents:              return this.agentsViewController();
        }

        let vc = new BaseViewController("section-none-view");        
        vc.initWithResource("layout/base/SectionNoneView.html");

        return vc;
    }

    reset(){
        this.section_cache.reset();
    }

    get canSeeDashBoard():boolean{
        let permissions = SettingsHelper.sharedInstance().permisisons;
        let value = permissions[3]; // Dashboard
        return (value == "1");
    }
    
    private dashBoardViewController() {
        return this.section_cache.sectionByType(SectionViewControllerType.DashBoard, () => {
            let vc = new ReportViewController("report-detail-view");
            vc.initWithResource("layout/reports/ReportDetailView.html");
            vc.title = MIOLocalizeString("DASHBOARD", "DASHBOARD");
            vc.reportScriptPath = "python/0_dashboard.py";
            vc.showSectionButton = true;

            let nc = new MUINavigationController();
            nc.initWithRootViewController(vc);

            return nc;
        }); 
    }

    private newSplitViewController(masterViewController:MUIViewController, detailViewController:MUIViewController) : MUISplitViewController {
        let vc = new MUISplitViewController();
        vc.init();
        vc.setMasterViewController(masterViewController);
        vc.setDetailViewController(detailViewController);

        return vc;
    }

    private summaryReportViewController(title:string, id:string, path:string = null, addNavigationController = false) : ReportViewController {        
        let vc = ReportViewController.newInstance();
        vc.title = title; // MIOLocalizeString(title, title);
        if (path != null) vc.reportScriptPath = path;
        else vc.reportID = id;
        vc.showSectionButton = true;

        if (addNavigationController == false) return vc;

        let nc = new MUINavigationController();
        nc.initWithRootViewController(vc);
        return nc;
    }
    
    private operationSummaryViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.OperationSummary, () => {
            return this.summaryReportViewController( MIOLocalizeString("OPERATION_SUMMARY", "OPERATION SUMMARY"), "99000000-0000-2222-0001-000000000001", "python/1_operation_summary.py", true);
        });
    }
    
    private salesSummaryViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.SalesSummary, () => {
            return this.summaryReportViewController( MIOLocalizeString("SALES_SUMMARY", "SALES SUMMARY"), "99000000-0000-2222-0001-000000000002", "python/1_sales_summary.py", true);
        });
    }
    
    private stockFlowsSummaryViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.StockFlowsSummary, () => {
            return this.summaryReportViewController( MIOLocalizeString("STOCKFLOWS_SUMMARY", "STOCKFLOWS SUMMARY"), "99000000-0000-2222-0001-000000000003", "python/1_stock_flow_summary.py", true);
        });
    }

    private ordersSummaryViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.OrdersSummary, () => {
            return this.summaryReportViewController( MIOLocalizeString("ORDERS_SUMMARY", "ORDERS SUMMARY"), "99000000-0000-2222-0001-000000000004", "python/1_order_summary.py", true);
        });    
    }
    
    private productMixSummaryViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.ProductMixSummary, () => {
            return this.summaryReportViewController( MIOLocalizeString("PRODUCT_MIX_SUMMARY", "PRODUCT MIX SUMMARY"), "99000000-0000-2222-0001-000000000005", "python/1_product_mix_summary.py", true);
        });
    }

    private clientHistorySummaryViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.ClientHistorySummary, () => {
            return this.summaryReportViewController( MIOLocalizeString("CLIENT_HISTORY_SUMMARY", "CLIENT HISTORY SUMMARY"), "99000000-0000-2222-0001-000000000006", "python/1_client_summary.py", true);
        });
    }

	private workerSessionToolViewController() {
		return this.section_cache.sectionByType(SectionViewControllerType.WorkerSessionTool, () => {
		    let vc = new ReportViewController("report-summary-view");
            vc.initWithResource("layout/workers/WorkerSessionToolView.html");
                
            return vc;
		});
	}    
    
    private advancedReportsViewController() {
        return this.section_cache.sectionByType(SectionViewControllerType.AdvancedReports, () => {
            let mvc = ReportListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("Report", NoItemSelectedViewControllerType.Report);        
            return this.newSplitViewController(mvc, dvc);
        });
    }
    
    private logsViewController():LogViewController{
        return this.section_cache.sectionByType(SectionViewControllerType.Logs, () => {
            let vc:LogViewController
        
            if (MIOCoreIsPhone() == true) {
                vc = new LogViewController("log-view_phone");
                vc.initWithResource("layout/log/LogView_phone.html");                    
            }
            else {
                vc  = new LogViewController("log-view");
                vc.initWithResource("layout/log/LogView.html");    
            }
            return vc; 
        });        
    }

    //
    // ACOUNTING
    // 
    
    private cashdeskViewController(){        
        return this.section_cache.sectionByType(SectionViewControllerType.CashDesk, () => {
            let mvc = CashDeskListViewController.newInstance();

            // let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("CashDesk", NoItemSelectedViewControllerType.CashDesk);
            let dvc = CashDeskDetailViewController.newInstance();
            let dnc = new MUINavigationController();
            dnc.initWithRootViewController(dvc);

            return this.newSplitViewController(mvc, dnc);
        });
    }
    
    private ticketsViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.POSTickets, () => {
        
            let mvc = ArchivedDocumentListViewController.newInstance();
            mvc.documentType = ArchivedDocumentType.receipt;

            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("Ticket", NoItemSelectedViewControllerType.Ticket);

            return this.newSplitViewController(mvc, dvc);
        });
    }

    private posInvoicesViewController(){    
        return this.section_cache.sectionByType(SectionViewControllerType.POSInvoices, () => {
        
            let mvc = ArchivedDocumentListViewController.newInstance();
            mvc.documentType = ArchivedDocumentType.invoice;

            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("Invoice", NoItemSelectedViewControllerType.Invoice);

            return this.newSplitViewController(mvc, dvc);
        });
    }
    
    private salesInvoicesViewController(){    
        return this.section_cache.sectionByType(SectionViewControllerType.SalesInvoices, () => {        
            let mvc = SalesInvoiceListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("Invoice", NoItemSelectedViewControllerType.Invoice);
            return this.newSplitViewController(mvc, dvc);
        });
    }
    
    private purchaseInvoicesViewController(){    
        return this.section_cache.sectionByType(SectionViewControllerType.PurchaseInvoices, () => {        
            let mvc = PurchaseInvoiceListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("Invoice", NoItemSelectedViewControllerType.Invoice);
            return this.newSplitViewController(mvc, dvc);
        });
    }

    private quotationDocumentsViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.QuotationDocuments, () => {
            let mvc = QuotationListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("QuotationDocument", NoItemSelectedViewControllerType.QuotationDocument);
            return this.newSplitViewController(mvc, dvc);
        });
    }


    private banksViewController(){    
        return this.section_cache.sectionByType(SectionViewControllerType.BankAccount, () => {        
            let mvc = BankListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("BankAccount", NoItemSelectedViewControllerType.BankAccount);
            return this.newSplitViewController(mvc, dvc);
        });
    }
    
    private ledgerAccountReconciliationViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.LedgerAccountReconciliation, () => {
            return LedgerAccountReconciliationViewController.newInstance();
        });
    }
    
    private paymentInstallmentsViewController() : PaymentInstallmentViewController {
        return this.section_cache.sectionByType(SectionViewControllerType.PaymentInstallments, () => {
            return PaymentInstallmentViewController.newInstance();
        });
    }
    
    private pendingPaymentsViewController() : MUIViewController {
        return this.section_cache.sectionByType(SectionViewControllerType.PendingPayments, () => {
            return PendingPaymentsViewController.newInstance();
        });
    }

    private loansViewController() : MUIViewController {
        return this.section_cache.sectionByType(SectionViewControllerType.Loans, () => {                
            let mvc = LoanListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("Loan", NoItemSelectedViewControllerType.Loan);    
            return this.newSplitViewController(mvc, dvc);
        });            
    }
    
    private onlineOrdersViewController() : MUIViewController {
        return this.section_cache.sectionByType(SectionViewControllerType.OnlineOrders, () => {        
            let mvc = OnlineOrderListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("OnlineOrder", NoItemSelectedViewControllerType.OnlineOrder);
        
            return this.newSplitViewController(mvc, dvc);
        });
    }

    private onlinePlatformsViewController() {
        return this.section_cache.sectionByType(SectionViewControllerType.OnlinePlatforms, () => {
            return OnlinePlatformViewController.newInstance();            
        });
    }

    //
    // USERS
    //
    
    private clientsViewController() : MUIViewController {
        return this.section_cache.sectionByType(SectionViewControllerType.Client, () => {
            let mvc = ClientsListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("Client", NoItemSelectedViewControllerType.Client);
            return this.newSplitViewController(mvc, dvc);
        });
    }
    
    private workersViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.Worker, () => {        
            let mvc = WorkerListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("Workers", NoItemSelectedViewControllerType.Worker);
            return this.newSplitViewController(mvc, dvc);
        });
    }
    
    private workersAdminViewController() {
        return this.section_cache.sectionByType(SectionViewControllerType.WorkerAdmin, () => {
            return WorkerAdminViewController.newInstance();
        });
    }
    
    private userAccessViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.UserAccess, () => {
            return UserAccessViewController.newInstance();
        });
    }

    /*private _reportsAccessViewController:ReportsAccessViewController = null;    
    private reportsAccessViewController(){
        if (this._reportsAccessViewController != null) return this._reportsAccessViewController;

        this._reportsAccessViewController = new ReportsAccessViewController('users-view');
        this._reportsAccessViewController.initWithResource("layout/users/UsersView.html");        

        return this._reportsAccessViewController;
    }*/
    
    private cardsViewController() {
        return this.section_cache.sectionByType(SectionViewControllerType.Cards, () => {
            return CardListViewController.newInstance();
        });
    }
        
    private partnersViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.Partners, () => {        
            let mvc = PartnerListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("Partner", NoItemSelectedViewControllerType.Party);
            return this.newSplitViewController(mvc, dvc);
        });
    }

    //
    // PRODUCTS
    //
    
    private productsViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.Product, () => {            
            let mnc = new MUINavigationController();
            mnc.initWithRootViewController( ProductListViewController.newInstance() );            
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("Product", NoItemSelectedViewControllerType.Product);            
            return this.newSplitViewController(mnc, dvc);
        });
    }
    
    private categoriesViewController() {        
        return this.section_cache.sectionByType(SectionViewControllerType.ProductCategory, () => {
            let mvc = ProductCategoryListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("ProductCategory", NoItemSelectedViewControllerType.ProductCategory);
            return this.newSplitViewController(mvc, dvc);
        });
    }
    
    private productModifiersViewController() {        
        return this.section_cache.sectionByType(SectionViewControllerType.ProductModifiers, () => {        
            let mnc = new MUINavigationController();
            mnc.initWithRootViewController( ProductModifiersListViewController.newInstance() );
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("Product modifiers", NoItemSelectedViewControllerType.ProductModifiers);
            return this.newSplitViewController(mnc, dvc);
        });
    }
    
    private menusViewController() : MUIViewController {
        return this.section_cache.sectionByType(SectionViewControllerType.Menus, () => {            
            let mnc = new MUINavigationController();
            mnc.initWithRootViewController( MenuListViewController.newInstance() );
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("Menus", NoItemSelectedViewControllerType.Menus);
            return this.newSplitViewController(mnc, dvc);
        });
    }

    private productComponentsViewController() : MUIViewController {
        return this.section_cache.sectionByType(SectionViewControllerType.ProductAdmin, () => {
            return ProductAdminListViewController.newInstance();
        });
    }
    
    private offersViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.Offers, () => {        
            let mvc = OffersListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("Offer", NoItemSelectedViewControllerType.Offer);
            return this.newSplitViewController(mvc, dvc);
        });
    }
    
    private productRatesViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.ProductRates, () => {
            let mnc = new MUINavigationController();
            mnc.initWithRootViewController( ProductRatesListViewController.newInstance() );
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("ProductRates", NoItemSelectedViewControllerType.ProductRates);
            return this.newSplitViewController(mnc, dvc);
        });
    }
    
    private productPresetsViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.ProductPresets, () => {
            let mvc = ProductPresetListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("ProductPresets", NoItemSelectedViewControllerType.ProductPresets);
            return this.newSplitViewController(mvc, dvc);
        });
    }

    //
    // BOOKINGS
    //
    
    private bookingsViewController() {
        return this.section_cache.sectionByType(SectionViewControllerType.Bookings, () => {
            let vc = new BookingsViewController();
            vc.init();
            return vc;
        });
    }

    private noShowViewController() {
        return this.section_cache.sectionByType(SectionViewControllerType.NoShow, () => {
            return NoShowViewController.newInstance();
        });
    }

    private guestsViewController() : MUIViewController {
        return this.section_cache.sectionByType(SectionViewControllerType.Guests, () => {
            return GuestViewController.newInstance();
        });
    }
    
    private guestListViewController() {
        return this.section_cache.sectionByType(SectionViewControllerType.GuestLists, () => {
            let mvc = GuestlistListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("GuestList", NoItemSelectedViewControllerType.GuestList);
            return this.newSplitViewController(mvc, dvc);
        });
    }
            
    private bookingIntermediaryViewController() {
        return this.section_cache.sectionByType(SectionViewControllerType.BookingIntermediary, () => {
            let mvc = BookingIntermediaryListViewController.newInstance();        
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("BookingIntermediary", NoItemSelectedViewControllerType.BookingIntermediary)        
            return this.newSplitViewController(mvc, dvc);
        });
    }
    
    private eventsViewController() {
        return this.section_cache.sectionByType(SectionViewControllerType.Events, () => {
            let mvc = EventListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("Events", NoItemSelectedViewControllerType.Events);
            return this.newSplitViewController(mvc, dvc);
        });
    }
    
    private partiesViewController() {
        return this.section_cache.sectionByType(SectionViewControllerType.Parties, () => {
            let mvc = PartyListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("Parties", NoItemSelectedViewControllerType.Party);        
            return this.newSplitViewController(mvc, dvc);
        });
    }

    
    private partyEventsViewController() {
        return this.section_cache.sectionByType(SectionViewControllerType.PartyEvents, () => {
            let mvc = PartyEventListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("PartyEvents", NoItemSelectedViewControllerType.Party);
            return this.newSplitViewController(mvc, dvc);
        });
    }


    //
    // ONLINE
    //
    
    private deliveryRoutesController(){
        return this.section_cache.sectionByType(SectionViewControllerType.DeliveryRoutes, () => {            
            let mnc = new MUINavigationController();
            mnc.initWithRootViewController( DeliveryRoutesListViewController.newInstance() );            
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("DeliveryRoutes", NoItemSelectedViewControllerType.DeliveryRoutes);
            return this.newSplitViewController(mnc, dvc);
        });
    }

    //
    // STOCK
    //
    
    private suppliersViewController() {        
        return this.section_cache.sectionByType(SectionViewControllerType.Supplier, () => {
            let mvc = SupplierListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("Supplier", NoItemSelectedViewControllerType.Supplier);
            return this.newSplitViewController(mvc, dvc);
        });
    }
        
    private stockProductsViewController() : MUIViewController {
        return this.section_cache.sectionByType(SectionViewControllerType.Stock, () => {

            let mvc = ProductListViewController.newInstance();
            mvc.productType = ProductType.Stock;

            let mnc = new MUINavigationController();
            mnc.initWithRootViewController(mvc);

            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("Product", NoItemSelectedViewControllerType.Product);

            return this.newSplitViewController(mnc, dvc);
        });
    }
    
    private stockViewController() {      
        return this.section_cache.sectionByType(SectionViewControllerType.Stock, () => {
        
            let vc = ReportViewController.newInstance();
            vc.title = MIOLocalizeString("STOCK_SUMMARY", "STOCK SUMMARY");
            vc.reportScriptPath = "python/1_stock_current_summary.py";
            vc.showSectionButton = true;

            let nc = new MUINavigationController();
            nc.initWithRootViewController(vc);

            return nc;
        });
    }

    private inventoryNotesViewController() {        
        return this.section_cache.sectionByType(SectionViewControllerType.InventoryNote, () => {        
            let mvc = InventoryNoteListViewController.newInstance()            
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("InventoryNote", NoItemSelectedViewControllerType.InventoryNote);
            return this.newSplitViewController(mvc, dvc);
        });
    }

    
    private inventoryTemplateViewController() {        
        return this.section_cache.sectionByType(SectionViewControllerType.StockTemplates, () => {
            let mvc = StockTemplateListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("StockTemplate", NoItemSelectedViewControllerType.StockTemplate);
            return this.newSplitViewController(mvc, dvc);
        });
    }
    
    private movementNotesViewController() {
        return this.section_cache.sectionByType(SectionViewControllerType.MovementNote, () => {
            let mvc = MovementNoteListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("MovementNote", NoItemSelectedViewControllerType.MovementNote);
            return this.newSplitViewController(mvc, dvc);
        });
    }

    private transferNotesViewController() {
        return this.section_cache.sectionByType(SectionViewControllerType.TransferNote, () => {
            let mvc = TransferNoteListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("TransferNote", NoItemSelectedViewControllerType.MovementNote);
            return this.newSplitViewController(mvc, dvc);
        });
    }


    private outputNotesViewController() {
        return this.section_cache.sectionByType(SectionViewControllerType.OutputNote, () => {
            let mvc = OutputNoteListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("OutputNote", NoItemSelectedViewControllerType.OutputNote);        
            return this.newSplitViewController(mvc, dvc);
        });
    }
    
    private lowStockProductViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.LowStockOrder, () => {
            let mvc = LowStockListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("LowStockProducts", NoItemSelectedViewControllerType.LowStockProducts);
            return this.newSplitViewController(mvc, dvc);
        });
    }

    private buyOrdersViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.BuyOrder, () => {
            let mvc = BuyOrderListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("BuyOrders", NoItemSelectedViewControllerType.BuyOrder);
            return this.newSplitViewController(mvc, dvc);
        });
    }
    
    private supplierOrdersViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.SupplierOrder, () => {
            let mvc = SupplierOrderListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("SupplierOrder", NoItemSelectedViewControllerType.SupplierOrder);
            return this.newSplitViewController(mvc, dvc);
        });
    }

    private supplierNotesViewController() {
        return this.section_cache.sectionByType(SectionViewControllerType.SupplierNote, () => {
            let mvc = SupplierNoteListViewController.newInstance();            
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("SupplierNote", NoItemSelectedViewControllerType.SupplierNote);
            return this.newSplitViewController(mvc, dvc);
        });
    }

    private supplierReturnNotesViewController() {
        return this.section_cache.sectionByType(SectionViewControllerType.SupplierReturnNote, () => {
            let mvc = SupplierReturnNoteListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("SupplierNote", NoItemSelectedViewControllerType.SupplierNote);        
            return this.newSplitViewController(mvc, dvc);
        });
    }

    private deliveryNotesViewController() {     
        return this.section_cache.sectionByType(SectionViewControllerType.DeliveryNote, () => {
            let mvc = DeliveryNoteListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("DeliveryNote", NoItemSelectedViewControllerType.DeliveryNote)
            return this.newSplitViewController(mvc, dvc);
        });
    }

    private deliveryOrdersViewController() {     
        return this.section_cache.sectionByType(SectionViewControllerType.DeliveryOrder, () => {
            let mvc = DeliveryOrderListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("DeliveryNote", NoItemSelectedViewControllerType.DeliveryOrder)
            return this.newSplitViewController(mvc, dvc);
        });
    }
    
    private warehouseOrdersViewController() {        
        return this.section_cache.sectionByType(SectionViewControllerType.WarehouseOrder, () => {
            let mvc = WarehouseOrderListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("WarehouseOrder", NoItemSelectedViewControllerType.StockOrder);
            return this.newSplitViewController(mvc, dvc);
        });
    }


    private warehouseDeliveryViewController() {        
        return this.section_cache.sectionByType(SectionViewControllerType.WarehouseDelivery, () => {
            let mvc = WarehouseDeliveryListViewController.newInstance();        
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("WarehouseDelivery", NoItemSelectedViewControllerType.StockOrder);        
            return this.newSplitViewController(mvc, dvc);
        });
    }

    private warehouseInputViewController() : MUIViewController {
        return this.section_cache.sectionByType(SectionViewControllerType.WarehouseInput, () => {
            let mvc = WarehouseDeliveryListViewController.newInstance();        
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("WarehouseInput", NoItemSelectedViewControllerType.StockOrder);        
            return this.newSplitViewController(mvc, dvc);
        });
    }

    
    private internalReturnOrderViewController() {        
        return this.section_cache.sectionByType(SectionViewControllerType.InternalReturnOrder, () => {
            let mvc = InternalReturnOrderListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("InternalReturnOrderNoSelectedItem", NoItemSelectedViewControllerType.InternalReturnOrder);        
            return this.newSplitViewController(mvc, dvc);
        });
    }
    
    private inputNotesViewController() {        
        return this.section_cache.sectionByType(SectionViewControllerType.InputNote, () => {
            let mvc = InputNoteListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("InputNote", NoItemSelectedViewControllerType.InputNote);
            return this.newSplitViewController(mvc, dvc);
        });
    }

    // 
    // CONFIGURATION
    //

    private settingsViewController() {
        return this.section_cache.sectionByType(SectionViewControllerType.Settings, () => {
            let mvc = SetupViewController.newInstance();            
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("Setup", NoItemSelectedViewControllerType.Setup);        
            return this.newSplitViewController(mvc, dvc);
        });
    }

    private placesViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.Places, () => {
            let mvc = PlaceListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("Place", NoItemSelectedViewControllerType.Place);        
            return this.newSplitViewController(mvc, dvc);
        });
    }
        
    private dbBackupToolViewController() {
        return this.section_cache.sectionByType(SectionViewControllerType.DBBackup, () => {
            return DBBackupToolViewController.newInstance();
        });
    }

    private dbToolViewController() {
        return this.section_cache.sectionByType(SectionViewControllerType.DBTool, () => {
            return DBToolViewController.newInstance();
        });
    }
    
    private dbSyncViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.DBSync, () => {
            return DBSyncViewController.newInstance();
        });
    }

    private dbMappingViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.DBMapping, () => {
            return DBMappingViewController.newInstance();
        });
    }

    private syncLogViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.SyncLog, () => {
            let vc = SyncLogViewController.newInstance();
            let nc = new MUINavigationController();
            nc.initWithRootViewController(vc);
            return nc;
        });
    }
        
    private dbImportViewController(){    
        return this.section_cache.sectionByType(SectionViewControllerType.DBImport, () => {
            let vc = DBImportViewController.newInstance();
            return vc;
        });
    }
    
    private dbConsumptionLogViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.DBConsumptionLog, () => {
            let vc = DBConsumptionLogViewController.newInstance();
            return vc;
        });
    }
    
    private reportBuilderViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.ReportBuilder, () => {
            let mvc = ReportScriptListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("ReportBuilder", NoItemSelectedViewControllerType.ReportBuilder);
            return this.newSplitViewController(mvc, dvc);
        });
    }

    //
    // DUAL LINK
    // 

    private businessLicensesViewController():MUISplitViewController {
        return this.section_cache.sectionByType(SectionViewControllerType.BusinessLicenses, () => {
            let mvc = LicensesListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("Licenses", NoItemSelectedViewControllerType.License);        
            return this.newSplitViewController(mvc, dvc);
        });
    }
    
    private licensesViewController():ApplicationLicenseListViewController { 
        return this.section_cache.sectionByType(SectionViewControllerType.ApplicationLicenses, () => {
            let vc = ApplicationLicenseListViewController.newInstance();
            return vc;
        });
    }

    
    private supportTicketsViewController():MUISplitViewController{
        return this.section_cache.sectionByType(SectionViewControllerType.SupportTickets, () => {
            let mvc = SupportTicketListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("SupportTickets", NoItemSelectedViewControllerType.SupportTickets);        
            return this.newSplitViewController(mvc, dvc);
        });
    }
    
    private supportFilesViewController() : SupportFileViewController {
        return this.section_cache.sectionByType(SectionViewControllerType.SupportFiles, () => {
            let vc = SupportFileViewController.newInstance();
            return vc;
        });
    }
    
    private roomScheduleController():RoomScheduleViewController{
        return this.section_cache.sectionByType(SectionViewControllerType.RoomSchedule, () => {
            return RoomScheduleViewController.newInstance();
        });
    }

    private roomBookingController():RoomBookingListViewController{
        return this.section_cache.sectionByType(SectionViewControllerType.RoomBooking, () => {
            return RoomBookingListViewController.newInstance();
        });
    }

    private tableMapViewController():TableMapViewController {
        return this.section_cache.sectionByType(SectionViewControllerType.TableMap, () => {
            return TableMapViewController.newInstance();
        });
    }
    
    private appConfigurationViewController():MUISplitViewController {
        return this.section_cache.sectionByType(SectionViewControllerType.AppConfiguration, () => {
            let mvc = ApplicationListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("AppConfiguration", NoItemSelectedViewControllerType.AppConfiguration);
            return this.newSplitViewController(mvc, dvc);
        });
    }    
    
    private clockinViewController():MUIViewController {
        return this.section_cache.sectionByType(SectionViewControllerType.WorkerClockIn, () => {
            return  WorkerClockInViewController.newInstance();
        });
    }
    
    private distributorsViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.Distributors, () => {
            let mvc = DistributorListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("Distributor", NoItemSelectedViewControllerType.Distributor);
            return this.newSplitViewController(mvc, dvc);
        });
    }
    
    private agentsViewController(){
        return this.section_cache.sectionByType(SectionViewControllerType.Agents, () => {
            let vc = AgentListViewController.newInstance();
            return vc;
        });
    }

    private appConsumptionProfileViewController():MUISplitViewController {
        return this.section_cache.sectionByType(SectionViewControllerType.AppConsumptionProfile, () => {
            let mvc = ConsumptionProfileListViewController.newInstance();
            let dvc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("AppConsumptionProfile", NoItemSelectedViewControllerType.AppConsumptionProfile);
            return this.newSplitViewController(mvc, dvc);
        });
    }

    private wineCellarProductsViewController():WineCellarProductsViewController { 
        return this.section_cache.sectionByType(SectionViewControllerType.WineCellarProducts, () => {
            return WineCellarProductsViewController.newInstance();
        });
    }
}
